import { BrowserRouter as Router, Routes, Route} from "react-router-dom";

// styles
import GlobalStyles from "./styles/GlobalStyles";

// pages
import Login from "./pages/entryPages/Login";
import Register from "./pages/entryPages/Register";
import RegisterNew from "./pages/entryPages/RegisterNew";

import ForgotPassword from "./pages/entryPages/ForgotPassword";
import MainLayout from "./layouts/MainLayout";

import Home from "./pages/single/Home";

// routes
import PrivateRoute from "./routes/PrivateRoute";

import AdresYonetimi from "./pages/yukIslemleri/AdresYonetimi";
import AracYetkiBelgesiSorgulamaYukIslemleri from "./pages/yukIslemleri/AracYetkiBelgesiSorgulamaYukIslemleri";

import KasaDefteri from "./pages/single/KasaDefteri";

// all access
import KDVveTevkifatHesaplama from "./pages/hesaplamalar/KDVveTevkifatHesaplama";
import KmHesaplama from "./pages/hesaplamalar/KmHesaplama";
import Raporlar from "./pages/single/Raporlar";

import Uyeler from "./pages/uyelerveAraclar/Uyeler";
import Araclar from "./pages/uyelerveAraclar/Araclar";
import AracYetkiBelgesiSorgulamaUyelerVeAraclar from "./pages/uyelerveAraclar/AraçYetkiBelgeSorgulamaUyelerVeAraclar";

import IsArayanSuruculer from "./pages/ilanlar/IsArayanSuruculer";
import KiralikAraclar from "./pages/ilanlar/KiralikAraclar";
import SurucuArayanlar from "./pages/ilanlar/SurucuArayanlar";
import SatilikAraclar from "./pages/ilanlar/SatilikAraclar";

import UETDSYukBildirimi from "./pages/egeYurtAdmin/UETDSYukBildirimi";

import BildirimGonder from "./pages/egeYurtAdmin/BildirimGonder";
import Egeyurtİletisim from "./pages/egeYurtAdmin/Egeyurtİletisim";
import KullaniciIslemleri from "./pages/egeYurtAdmin/KullaniciIslemleri";
import SanalGarajIslemleri from "./pages/egeYurtAdmin/SanalGarajIslemleri";
import YuklerListBaslikVeAciklamaEkle from "./pages/egeYurtAdmin/YuklerListBaslikVeAciklamaEkle";

import FirmaBilgileri from "./pages/profilim/FirmaBilgileri";
import FirmaBelgeleri from "./pages/profilim/FirmaBelgeleri";
import Kullanicilar from "./pages/profilim/Kullanicilar";
import Araclarim from "./pages/profilim/Araclarim";
import Suruculerim from "./pages/profilim/Suruculerim";

import FirmaKaraListesi from "./pages/single/FirmaKaraListesi";

import NotFound from "./pages/single/NotFound";

import { ThemeProvider } from "styled-components";
import { dark, light } from "./styles/Theme";

import { useSelector } from "react-redux";
import GunlukFaturaVeDetayYukleme from "./pages/egeYurtAdmin/GunlukFaturaVeDetayYukleme";
import YorumOnaylari from "./pages/egeYurtAdmin/YorumOnaylari";
import ResimOnaylari from "./pages/egeYurtAdmin/ResimOnaylari";
import FirmaCezaVeUyariSorgulama from "./pages/egeYurtAdmin/FirmaCezaVeUyariSorgulama";
import SeferMaliyetKayitlari from "./pages/egeYurtAdmin/SeferMaliyetKayitlari";
import SeferMaliyetBligileri from "./pages/egeYurtAdmin/SeferMaliyetBligileri";
import SigortaTeklifi from "./pages/sigortaTeklif/SigortaTeklifi";
import SigortaListesi from "./pages/egeYurtAdmin/sigorta/SigortaListesi";
import Help from "./pages/single/Help";
import Settings from "./pages/single/Settings";
import KiralikAracArayanFirmalar from "./pages/ilanlar/KiralikAracArayanFirmalar";
import SikcaSorulanSorularAdmin from "./pages/egeYurtAdmin/SikcaSorulanSorularAdmin";
import GarajYogunlugu from "./pages/egeYurtAdmin/GarajYogunlugu";
import Firmalarim from "./pages/devamliAraclarimFirmalarim/Firmalarim";
import AdminSettings from "./pages/egeYurtAdmin/AdminSettings";
import KamyoonKullanimKurallariAdmin from "./pages/egeYurtAdmin/KamyoonKullanimKurallariAdmin";
import SeraGaz from "./pages/hesaplamalar/SeraGaz";
import AracKasaTypes from "./pages/egeYurtAdmin/AracKasaTypes";
import KamyonKullanimKurallari from "./pages/hakkında/KamyonKullanimKurallari";
import SikcaSorulanSorular from "./pages/hakkında/SikcaSorulanSorular";
import KamyoonKullanimKilavuzu from "./pages/hakkında/KamyoonKullanimKilavuzu";
import AddLoad from "./pages/topPages/AddLoad";
import LoadList from "./pages/topPages/LoadList";
import AtananlarList from "./pages/topPages/AtananlarList";
import YuklemedeList from "./pages/topPages/YuklemedeList";
import SeferdeList from "./pages/topPages/SeferdeList";
import BosaltmadaList from "./pages/topPages/BosaltmadaList";
import TamamlananSeferlerList from "./pages/topPages/TamamlananSeferlerList";
import YapayZekaControl from "./pages/egeYurtAdmin/YapayZekaControl";
import JobList from "./pages/yukIslemleri/JobList";
import AdminMobilUyeler from "./pages/egeYurtAdmin/AdminMobilUyeler";
import AdminAraclar from "./pages/egeYurtAdmin/AdminAraclar";
import YapayZekaMesajlasmaGecmisi from "./pages/egeYurtAdmin/YapayZekaMesajlasmaGecmisi";
import WebMaliyetHesapSonuc from "./pages/egeYurtAdmin/WebMaliyetHesapSonuc";
import KestigimEArsivFaturalarim from "./pages/EArsivPages/KestigimEArsivFaturalarim";
import BanaKesilenEArsivFaturalar from "./pages/EArsivPages/BanaKesilenEArsivFaturalar";
import EArsivFaturaKes from "./pages/EArsivPages/EArsivFaturaKes";
import EArsivGibHesabi from "./pages/EArsivPages/EArsivGibHesabi";
import NakliyeIndex from "./pages/egeYurtAdmin/NakliyeIndex";
import EArsivKayitliMusteri from "./pages/EArsivPages/EArsivKayitliMusteri";
import YellowPage from "./pages/single/YellowPage";
import KamyoonEngellenenAraclar from "./pages/egeYurtAdmin/KamyoonEngellenenAraclar";
import YapayZekaRoleContent from "./pages/egeYurtAdmin/YapayZekaRoleContent";
import { ToastContainer } from 'react-toastify';
import SistemIslemKayitlari from "./pages/egeYurtAdmin/SistemIslemKayitlari";
import PanelUyeDenetim from "./pages/egeYurtAdmin/PanelUyeDenetim";
import AdminPanelUsers from "./pages/egeYurtAdmin/AdminPanelUsers";
import BolgedekiTekliflerim from "./pages/yukIslemleri/BolgedekiTekliflerim";
import Messages from "./pages/messagesNotifications/Messages";
import AdminIlanlar from "./pages/egeYurtAdmin/AdminIlanlar";
import IsOrtaklari from "./pages/profilim/IsOrtaklari";
import Iletisim from "./pages/hakkında/Iletisim";
import DetailLoadPage from "./pages/detailTopPages/DetailLoadPage";
import DetailShipments from "./pages/detailTopPages/DetailShipments";
import TahsilatBildirimi from "./pages/egeYurtAdmin/TahsilatBildirimi";
import KamyonGarajYogunluk from "./pages/single/KamyonGarajYogunluk";
import AkilliKamyoon from "./pages/single/AkilliKamyoon";
import KamyoonWebBlogs from "./pages/egeYurtAdmin/KamyoonWebBlogs";
import UETDSYukBildirimiLojistik from "./pages/single/UETDSYukBildirimi";
import OpenLocationTracking from "./pages/single/OpenLocationTracking";
import NakliyeHesaplama from "./pages/hesaplamalar/NakliyeHesaplama";
import PortalBildirimGonder from "./pages/egeYurtAdmin/PortalBildirimGonder";
import Notification from "./pages/messagesNotifications/Notification";
import KarayollariIstasyonlari from "./pages/egeYurtAdmin/KarayollariIstasyonlari";
import UetdsBildirimKontrol from "./pages/egeYurtAdmin/UetdsBildirimKontrol";
import YukBulMessageBlocking from "./pages/egeYurtAdmin/YukBulMessageBlocking";
import KonumGoruntuleme from "./pages/egeYurtAdmin/KonumGoruntuleme";
import AdminYukAriyorum from "./pages/egeYurtAdmin/AdminYukAriyorum";
import YukBul from "./pages/egeYurtAdmin/YukBul";
import YukBulMobil from "./pages/egeYurtAdmin/YukBulMobil";
import SmsBildirim from "./pages/egeYurtAdmin/OTPSmsBildirim";
import SmsRapor from "./pages/egeYurtAdmin/OTPSmsBildirim";
import SayfaOlusturma from "./pages/egeYurtAdmin/SayfaOlusturma";
import GorselOnaylari from "./pages/egeYurtAdmin/ResimOnaylari";
import Ayarlar from "./pages/profilim/Ayarlar";
import AdminKullaniciRolIslemleri from "./pages/egeYurtAdmin/AdminKullaniciRolIslemleri";
import BranchDriverLocation from "./pages/egeYurtAdmin/BranchDriverLocation";

import KamyoonYollarda from "./pages/egeYurtAdmin/KamyoonYollarda";
import LogPanel from "./pages/logs/LogPanel";
import RegularDriversVehicles from "./pages/devamliAraclarimFirmalarim/RegularDriversVehicles";
import Anket from "./pages/topPages/Anket";
import MobileDeletedAccounts from "./pages/egeYurtAdmin/MobileDeletedAccounts";

function App() {

  const { theme } = useSelector((state) => state.layout);

  return (
    <Router>
      <ThemeProvider theme={theme === "dark" ? dark : light}>
        <GlobalStyles />
        <ToastContainer  className={"toast-container"}/>
        <Routes>
          <Route path="/giris-yap" element={<Login />} />
          {/*  <Route path="/kayit-ol" element={<Register />} />*/}
         <Route path="/kayit-ol" element={<RegisterNew />} /> 

         <Route path="/anket-3848" element={<Anket />} /> 
          
          <Route path="/sifremi-unuttum" element={<ForgotPassword />} />
          

          <Route path="/not-found" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/sefer-takip/:rId" element={<OpenLocationTracking />} />


          <Route
            path="/"
            element={
              <PrivateRoute>
                <MainLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Home />} />
            <Route
              path="/hesaplamalar/sera-gazi-emisyonu-hesaplama"
              element={<SeraGaz />}
            />


            {/* //! top menüler */}
            <Route path="/yuk-ekle" element={<AddLoad />} />
            <Route path="/yukler-listesi" element={<LoadList />} />
            <Route path="/atananlar" element={<AtananlarList />} />
            <Route path="/yuklemede" element={<YuklemedeList />} />
            <Route path="/seferde" element={<SeferdeList />} />
            <Route path="/bosaltmada" element={<BosaltmadaList />} />
            <Route
              path="/tamamlanan-seferler"
              element={<TamamlananSeferlerList />}
            />
            <Route path="/yuk-detay" element={<DetailLoadPage />} />
            <Route path="/sevkiyat-detay" element={<DetailShipments />} />

            {/* //! Yük işlemleri */}
            {/* <Route path="/yuk-islemleri/is-listesi" element={<IsListesi />} /> */}
            <Route path="/yuk-islemleri/is-listesi" element={<JobList />} />

            {/* <Route
              path="/yuk-islemleri/devamli-araclarim"
              element={<DevamliAraclarimFirmalarim />}
            /> */}
            <Route
              path="/yuk-islemleri/plaka-sorgulama"
              element={<AracYetkiBelgesiSorgulamaYukIslemleri />}
            />
            <Route
              path="/yuk-islemleri/adres-yonetimi"
              element={<AdresYonetimi />}
            />
            <Route
              path="/yuk-islemleri/bolgedeki-tekliflerim"
              element={<BolgedekiTekliflerim />}
            />


            {/* //! Üyeler ve araçlar */}
            <Route
              path="/uyeler-ve-araclar/uyeler"
              element={<Uyeler />}
            />

            <Route
              path="/uyeler-ve-araclar/araclar"
              element={<Araclar />}
            />
           
            <Route
              path="/uyeler-ve-araclar/plaka-sorgulama"
              element={<AracYetkiBelgesiSorgulamaUyelerVeAraclar />}
            />

            {/* //! devamli araclarim - firmalarim */}
            <Route
              path="/suruculer-ve-araclarim/devamli-araclarim"
              element={<RegularDriversVehicles />}
            />
            <Route
              path="/yuk-islemleri/devamli-araclarim"
              element={<RegularDriversVehicles />}
            />
            <Route
              path="/suruculer-ve-araclarim/firmalarim"
              element={<Firmalarim />}
            />

            {/* //! yuk verende burası tek menü olacak */}
            {/* <Route path="/devamli-araclarim" element={<DevamliAraclarim />} /> */}

            {/* //! nakliye fiyat hesaplama */}
            <Route
              path="/hesaplamalar/nakliye-fiyat-hesaplama"
              element={<NakliyeHesaplama />}
            />
            <Route
              path="/hesaplamalar/km-hesaplama"
              element={<KmHesaplama />}
            />
            <Route
              path="/hesaplamalar/kdv-ve-tevkifat-hesaplama"
              element={<KDVveTevkifatHesaplama />}
            />

            {/* //! e-arşiv fatura */}
            <Route path="/e-arsiv/kestigim-faturalarim" element={<KestigimEArsivFaturalarim />} />
            <Route path="/e-arsiv/bana-kesilen-faturalar" element={<BanaKesilenEArsivFaturalar />} />
            <Route path="/e-arsiv/fatura-kes" element={<EArsivFaturaKes />} />
            <Route path="/e-arsiv/gib-hesabi" element={<EArsivGibHesabi />} />
            <Route path="/e-arsiv/kayitli-musteriler" element={<EArsivKayitliMusteri />} />
            {/* <Route path="/e-arsiv/mal-ve-hizmet-kayitlari" element={<EArsivKayitliMalHizmet />} /> */}

            {/* //! uygun sigorta bul */}
            <Route path="/uygun-sigorta-bul" element={<SigortaTeklifi />} />

            {/* //! İlanlar */}
            <Route
              path="/ilanlar/kiralik-arac-arayan-firmalar"
              index
              element={<KiralikAracArayanFirmalar />}
            />
            <Route
              path="/ilanlar/kiralik-araclar"
              element={<KiralikAraclar />}
            />
            <Route
              path="/ilanlar/is-arayan-surucular"
              element={<IsArayanSuruculer />}
            />
            <Route
              path="/ilanlar/surucu-arayanlar"
              element={<SurucuArayanlar />}
            />
            <Route
              path="/ilanlar/satilik-araclar"
              element={<SatilikAraclar />}
            />

            <Route path="/mesajlar" element={<Messages />} />
            <Route path="/bildirimler" element={<Notification />} />

            {/* //! Sarı sayfalar */}
            <Route path="/sari-sayfalar" element={<YellowPage />} />

            {/* //! Kasa Defteri */}
            <Route path="/kasa-defteri" element={<KasaDefteri />} />

            {/* //! raporlar */}
            <Route path="/raporlar" element={<Raporlar />} />

            {/* //! kamyon garaj yogunluklari */}
            <Route path="/kamyon-garaj-yogunluklari" element={<KamyonGarajYogunluk />} />

            <Route
              path="/u-etds-yuk-bildirimi"
              element={<UETDSYukBildirimiLojistik />}
            />

            {/* //!profilim menüsü */}
            <Route
              path="/profilim/firma-bilgileri"
              element={<FirmaBilgileri />}
            />
            <Route
              path="/profilim/firma-belgeleri"
              element={<FirmaBelgeleri />}
            />
            <Route path="/profilim/kullanicilar" element={<Kullanicilar />} />
            <Route path="/profilim/araclarim" element={<Araclarim />} />
            <Route path="/profilim/suruculerim" element={<Suruculerim />} />
            <Route path="/profilim/ayarlar" element={<Ayarlar />} />

            {/* //! Egeyurt admin */}
            <Route
              path="/admin/u-etds-yuk-bildirimi"
              element={<UETDSYukBildirimi />}
            />
            
            <Route
              path="/admin/egeyurt-iletisim"
              element={<Egeyurtİletisim />}
            />
            <Route path="/admin/bildirim-gonder" element={<BildirimGonder />} />
            <Route path="/admin/portal-bildirim-gonder" element={<PortalBildirimGonder />} />
            <Route
              path="/admin/yukler-list-baslik-ve-aciklama"
              element={<YuklerListBaslikVeAciklamaEkle />}
            />
            <Route
              path="/admin/kullanici-islemleri"
              element={<KullaniciIslemleri />}
            />
            <Route
              path="/admin/kullanici-rol-islemleri"
              element={<AdminKullaniciRolIslemleri />}
            />
            <Route
              path="/admin/sanal-garaj-islemleri"
              element={<SanalGarajIslemleri />}
            />
            <Route
              path="/admin/gunluk-fatura-ve-detay-yukleme"
              element={<GunlukFaturaVeDetayYukleme />}
            />
            <Route path="/admin/yorum-onaylari" element={<YorumOnaylari />} />
            <Route path="/admin/resim-onaylari" element={<ResimOnaylari />} />
            <Route
              path="/admin/firma-ceza-ve-uyari-sorgulama"
              element={<FirmaCezaVeUyariSorgulama />}
            />
            <Route
              path="/admin/sefer-maliyet-kayitlari"
              element={<SeferMaliyetKayitlari />}
            />
            <Route
              path="/admin/sefer-maliyet-bilgileri"
              element={<SeferMaliyetBligileri />}
            />
            <Route path="/admin/sigorta-listesi" element={<SigortaListesi />} />
            <Route
              path="/admin/arac-ve-kasa-tipleri"
              element={<AracKasaTypes />}
            />
            <Route
              path="/admin/kamyoon-engellenen-araclar"
              element={<KamyoonEngellenenAraclar />}
            />
            <Route path="/admin/garaj-yogunlugu" element={<GarajYogunlugu />} />
            <Route
              path="/admin/kamyoon-kullanim-kurallari"
              element={<KamyoonKullanimKurallariAdmin />}
            />
            <Route
              path="/admin/sikca-sorulan-sorular"
              element={<SikcaSorulanSorularAdmin />}
            />
            <Route path="/admin/ayarlar" element={<AdminSettings />} />
            <Route path="/admin/yapay-zeka-ayarlari" element={<YapayZekaControl />} />
            <Route path="/admin/mobil-uyeler" element={<AdminMobilUyeler />} />
            <Route path="/admin/panel-uyeler" element={<AdminPanelUsers />} />
            <Route path="/admin/araclar" element={<AdminAraclar />} />
            <Route path="/admin/yapay-zeka-mesajlasma-gecmisi" element={<YapayZekaMesajlasmaGecmisi />}/>
            <Route path="/admin/web-maliyet-sonuclari" element={<WebMaliyetHesapSonuc />} />
            <Route path="/admin/nakliye-index" element={<NakliyeIndex />} />
            <Route path="/admin/yapay-zeka-rol-belirleme" element={<YapayZekaRoleContent />} />
            <Route path="/admin/sistem-islem-kayitlari" element={<SistemIslemKayitlari />} />
            <Route path="/admin/panel-uye-denetim" element={<PanelUyeDenetim />} />
            <Route path="/admin/ilanlar" element={<AdminIlanlar />} />
            <Route path="/admin/tahsilat-bildirimi" element={<TahsilatBildirimi />} />
            <Route path="/admin/web-blog" element={<KamyoonWebBlogs />} />
            <Route path="/admin/karayollari" element={<KarayollariIstasyonlari />} />
            {/* <Route path="/admin/uetds-bildirim" element={<UetdsBildirimKontrol />} /> */}
            <Route path="/admin/uetds-bildirim" element={<UetdsBildirimKontrol />} />
            <Route path="/admin/yuk-bul-mesaj-engelleme" element={<YukBulMessageBlocking />} />
            <Route path="/admin/konum-goruntuleme" element={<KonumGoruntuleme />} />
            <Route path="/admin/yuk-ariyorum" element={<AdminYukAriyorum />} />
            <Route path="/admin/yuk-bul" element={<YukBul />} />
            <Route path="/admin/yuk-bul-mobil" element={<YukBulMobil />} />
            <Route path="/admin/sms-rapor" element={<SmsRapor />} />
            <Route path="/admin/sayfa-olusturma" element={<SayfaOlusturma />} />
            <Route path="/admin/gorsel-onaylari" element={<GorselOnaylari />} />
            <Route path="/admin/sube-uye-goruntuleme" element={<BranchDriverLocation />} />
            <Route path="/admin/kamyoon-yollarda" element={<KamyoonYollarda />} />

            <Route path="/admin/mobil-uygulama-silenler" element={<MobileDeletedAccounts />} />

            
            <Route path="/sube-uye-goruntuleme" element={<BranchDriverLocation />} />

            {/* //! Firma Kara Listesi */}
            <Route path="/engellenen-suruculer" element={<FirmaKaraListesi />} />

            {/* //! user dropdown menüler  */}
            <Route path="/ayarlar" element={<Settings />} />
            <Route path="/yardim" element={<Help />} />

            {/* //! Hakkında */}
            <Route
              path="/hakkinda/kamyoon-kullanim-kurallari"
              element={<KamyonKullanimKurallari />}
            />
            <Route
              path="/hakkinda/sikca-sorulan-sorular"
              element={<SikcaSorulanSorular />}
            />
            <Route
              path="/hakkinda/kamyoon-kullanim-kilavuzu"
              element={<KamyoonKullanimKilavuzu />}
            />

            <Route
              path="/hakkinda/iletisim"
              element={<Iletisim />}
            />

            <Route
              path="/profilim/projelerim"
              element={<IsOrtaklari />}
            />

            <Route
              path="/akilli-kamyoon"
              element={<AkilliKamyoon />}
            />

            <Route
              path="/log-panel"
              element={<LogPanel />}
            />


            

            {/* //! bu modal olacak */}
          </Route>
        </Routes>
      </ThemeProvider>
    </Router>
  );
}

export default App;
